import { CapitalActionTypes } from 'further-types/lp/capital-action';

export const CapitalActionTypeLabels = {
  [CapitalActionTypes.CapitalActionCreated]: 'Capital Action',
};
